import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { DataBlocks, Link, Arrow, I18n } from 'components';
import declint from 'utils/declint';
import * as dvr from 'utils/dvr';

import styles from './styles.pcss';
import {MOBILE_SERVICES_LINK, POSTPAID_SERVICES_LINK} from '../../constants';

const cx = classNames.bind(styles);

const Services = ({ data, error, isPostpaid }) => {
  if (error && error.type || data && data.error) {
    return null;
  }
  if (!data) {
    return null;
  }

  return (
    <DataBlocks.Block
      title={(
        <Link
          href={isPostpaid ? POSTPAID_SERVICES_LINK : MOBILE_SERVICES_LINK}
          onClick={() => dvr.playWaw('IVR_usl.wav')}
        >
          {data.connectedServicesCount
            ? declint(data.connectedServicesCount, [
              '%s подключенная услуга',
              '%s подключенных услуги',
              '%s подключенных услуг',
            ])
            : <I18n path="home.services.emptyMessage" />}
          <Arrow className={cx('arrow')} />
        </Link>
      )}
      info={(
        <Link href={data.servicesCatalogLink}>
          <I18n path="home.services.blockInfoLink" />
        </Link>
      )}
    />
  );
};

function mapStateToProps(state) {
  return {
    data: state.home.services.data,
    error: state.home.services.error,
    isPostpaid: state.application.isPostpaid,
  };
}

Services.propTypes = {
  data: PropTypes.object,
  error: PropTypes.object,
};

export default connect(mapStateToProps)(Services);
